"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntelligenceCenterURIIntegrationFeature = IntelligenceCenterURIIntegrationFeature;
const idps_consensus_1 = require("@branch-ts/idps-consensus");
const practice_idps_web_1 = require("@branch-ts/practice-idps-web");
const practice_verse_web_1 = require("@branch-ts/practice-verse-web");
const web_1 = require("@branch-ts/web");
const web_consensus_1 = require("@branch-ts/web-consensus");
const verset_consensus_1 = require("@project/verset_consensus");
function normalizeToICScopeURI(uri) {
    const scopeInfo = idps_consensus_1.ICProtocol.ICScopeURI.parse(uri)
        || idps_consensus_1.ICProtocol.ObjectiveURI.parse(uri)
        || idps_consensus_1.ICProtocol.ProgressURI.parse(uri)
        || idps_consensus_1.ICProtocol.SpotURI.parse(uri)
        || idps_consensus_1.ICProtocol.GoalURI.parse(uri);
    if (!scopeInfo) {
        return null;
    }
    return idps_consensus_1.ICProtocol.ICScopeURI.build({
        vendor: scopeInfo.vendor,
        scopeId: scopeInfo.scopeId,
    });
}
function IntelligenceCenterURIIntegrationFeature(config) {
    const makeObjectiveExplorer = (uri) => {
        const normalizedScopeURI = normalizeToICScopeURI(uri);
        if (normalizedScopeURI !== config.scopeURI) {
            return null;
        }
        const objectiveInfo = idps_consensus_1.ICProtocol.ObjectiveURI.parse(uri);
        return new practice_idps_web_1.ObjectiveExplorer({
            intelligenceCenter: config.intelligenceCenter,
            title: `${verset_consensus_1.VersetProtocol.ProductName.objective}s`,
            objectiveURI: objectiveInfo ? uri : null,
            focusURI: uri,
        });
    };
    web_consensus_1.PuriAppMechanism.register({
        name: "VersetObjectiveExplorer",
        registry: (input) => makeObjectiveExplorer(input.uri),
    });
    practice_verse_web_1.PopupAppSupportRegistryMechanism.register({
        name: "VersetObjectiveExplorer",
        registry: (input) => makeObjectiveExplorer(input.uri),
    });
    web_consensus_1.UIMechanism.registerAppURIResolver({
        resolver: (input) => {
            const normalizedScopeURI = normalizeToICScopeURI(input.uri);
            if (normalizedScopeURI !== config.scopeURI) {
                return false;
            }
            const app = web_consensus_1.PuriAppMechanism.ensure({
                uri: config.scopeURI,
            });
            if (!app) {
                return false;
            }
            const win = new web_1.WindowBehavior(app);
            win.setTitle(`${verset_consensus_1.VersetProtocol.ProductName.objective}s`);
            win.maximize();
            void win.show();
            return true;
        },
    });
}
